var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"catalog__list"},[_vm._l((_vm.products),function(product){return _c('ProductItem',{key:product.id,attrs:{"product":product}})}),_vm._v("> ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }